import React from 'react';

export default function PlacementJepang() {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">Placement ke Perusahaan Jepang</h1>
      <p className="text-gray-500">Halaman Placement ke Perusahaan Jepang</p>
    </div>
  );
}
